import { cls } from "@op/utils";
import type { HeadingNodeProps } from "../../../../../components/base/HeadingNode/HeadingNode";

function getTextClass(level: number) {
  switch (level) {
    case 1:
      return "text-heading-1 font-heading-1 text-default-font";
    case 2:
      return "text-heading-2 font-heading-2 text-default-font";
    case 3:
      return "text-heading-3 font-heading-3 text-default-font";
    case 4:
      return "text-heading-4 font-heading-4 text-default-font";
    default:
      return "text-body font-body text-default-font";
  }
}

const HeadingNode = ({
  level = 3,
  component = "span",
  children,
  className,
  ...rest
}: HeadingNodeProps) => {
  const Component = component;

  return (
    <Component className={cls(getTextClass(level), className)} {...rest}>
      {children}
    </Component>
  );
};

export default HeadingNode;
